'use client'

export default function GlobalError({
  error,
  reset
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <html>
      <body>
        <div style={{ padding: 24 }}>
          <h2>Application error</h2>
          <p style={{ color: '#666' }}>{error?.message || 'An unexpected error occurred.'}</p>
          {error?.digest ? (
            <p style={{ fontSize: 12, color: '#999' }}>Digest: {error.digest}</p>
          ) : null}
          <button
            onClick={() => reset()}
            style={{
              marginTop: 16,
              padding: '8px 12px',
              border: '1px solid #ccc',
              borderRadius: 6,
              background: '#f6f6f6',
              cursor: 'pointer'
            }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  )
}


